import { useQueryClient } from "@tanstack/react-query";

import { bookingConfigKeys } from "./query_keys";

export const useExceptionDaysInvalidate = () => {
  const queryClient = useQueryClient();

  return {
    invalidate: (calendarId: number) =>
      queryClient.invalidateQueries(bookingConfigKeys.exceptionDays(String(calendarId)))
  };
};
